import { Type } from 'class-transformer';
import { BankAccountSelectorResultDto } from '../../_models/bank-account-selector-result-dto';
import { VendorAccountRawDto } from './vendor-account-raw-dto';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { FileInfoDisplayResultDto } from '../../_models/file-info-display-result-dto';

export class VendorAccountEditorResultDto {
    @Type(() => VendorAccountRawDto)
    vendorAccount: VendorAccountRawDto;

    @Type(() => KeyValueResultDto)
    eftInactiveReasons: Array<KeyValueResultDto> = [];

    @Type(() => BankAccountSelectorResultDto)
    bankAccounts: Array<BankAccountSelectorResultDto> = [];

    @Type(() => KeyValueResultDto)
    billingFrequencies: Array<KeyValueResultDto> = [];

    @Type(() => KeyValueResultDto)
    accountBillingStatuses: Array<KeyValueResultDto> = [];

    @Type(() => FileInfoDisplayResultDto)
    eftForms: Array<FileInfoDisplayResultDto> = [];
}
